"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const module_1 = require("../core/module");
class ProfileModule extends module_1.default {
    constructor() {
        super(...arguments);
        this.endpoint = "/api/v1/profile/";
        this._canPaginate = false;
    }
    retrieve() {
        return this._list();
    }
    update(data) {
        return this._patch("my", data);
    }
    create(data) {
        return this._create(data);
    }
    toggleFavorite(discountId) {
        return this.axiosInstance.patch(`${this.endpoint}${discountId}/toggle_favorite/`);
    }
    async econometer() {
        const { data } = await this.axiosInstance.get(`${this.endpoint}econometer/`);
        data.progress.reverse();
        return data;
    }
    vinculatePromocode(promocode) {
        return this.axiosInstance.post(`/api/v1/vinculate_promocode/`, {
            promocode,
        });
    }
    async notifications(page = 1) {
        const { data } = await this.axiosInstance.get(`/api/v1/notifications/?page=${page}`);
        return data.results;
    }
}
exports.default = ProfileModule;
//# sourceMappingURL=profile.js.map